'use client';

import { useRouteTracking } from '@//data/tracking/useRouteTracking';

export const RouteTracker = () => {
  useRouteTracking();

  // This component renders nothing but handles route tracking
  return null;
};
